import { render, staticRenderFns } from "./ClientRegistry.vue?vue&type=template&id=44a89630&"
import script from "./ClientRegistry.vue?vue&type=script&lang=js&"
export * from "./ClientRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports